const userMenu = {
  personalAccount: "חשבון אישי",
  businessAccount: "חשבון עסקי",
  profile: "הפרופיל שלי",
  settings: "הגדרות",
  signOut: "התנתקות",
  switchAccount: "החלף חשבון",
  online: "מחובר",
  role: "תפקיד",
  admin: "מנהל",
  member: "חבר",
  viewer: "צופה",
} as const;
export default userMenu;
